import React from 'react'
import {BsLinkedin,BsGithub,BsDribbble} from 'react-icons/bs'

const Headersocials = () => {
  return (
    <div className="header-socials">
        <a href="https:linkedin.com" target="_blank"><BsLinkedin/></a>
        <a href="https:github.com/bonnieace" target="_blank"><BsGithub/></a>
        <a href="https:dribble.com" target="_black"><BsDribbble/></a>


    </div>
    )
}

export default Headersocials